import { render, staticRenderFns } from "./OrganismLayout.vue?vue&type=template&id=d49454b4"
import script from "./OrganismLayout.vue?vue&type=script&lang=ts"
export * from "./OrganismLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports